<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const CloseIcon = getIcon("CloseIcon");
</script>

{#if typeof CloseIcon === 'string'}
	<img src={CloseIcon} alt={$t(Verbiage.close_icon_alt, 'alts')} />
{:else if typeof CloseIcon === 'function'}
	<svelte:component this={CloseIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
